(function () {
    'use strict';

    angular
        .module('app.shared')
        .factory('scoreAdjustmentModal', scoreAdjustmentModal);

    var identity = angular.identity;

    scoreAdjustmentModal.$inject = ['$uibModal'];
    function scoreAdjustmentModal($uibModal) {
        return function scoreAdjustmentModal(score) {
            return $uibModal.open({
                component: 'sc3ScoreAdjustmentModal',
                resolve: {
                    score: identity.bind(null, score)
                },
                size: 'md'
            });
        }
    }
})();